import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 女优排行榜`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium">
            {article.tags[0]}
          </span>
          <span className="text-xs text-foreground-500">{article.publishDate}</span>
        </div>
        <h3 className="text-base font-heading text-foreground-950 font-bold mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{article.author}</span>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-eye-line"></i>
            {article.readCount.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}